import React from "react";
import { motion } from "framer-motion";
import { X, Check } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import SectionLabel from "./SectionLabel";

export default function BeforeAfter() {
  const { t } = useI18n();
  return (
    <section id="before-after" data-testid="before-after-section" className="relative py-20 md:py-32 border-t border-line">
      <div className="container-px mx-auto max-w-7xl">
        <SectionLabel>{t.beforeAfter.label}</SectionLabel>
        <h2 className="mt-6 font-display font-bold text-ink text-balance leading-[1.05]
                       text-3xl sm:text-5xl lg:text-6xl max-w-2xl">
          {t.beforeAfter.title}
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {/* BEFORE */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55 }}
            className="relative card-tactical p-6 md:p-8 overflow-hidden"
            style={{ background: "linear-gradient(180deg, rgba(255,59,59,0.06), #1C1F26 60%)" }}
            data-testid="before-card"
          >
            <div className="flex items-center gap-3">
              <span className="label-tag text-danger">{t.beforeAfter.before}</span>
              <span className="h-px flex-1 bg-danger/30" />
              <span className="mono-num text-[10px] text-danger">— STATE</span>
            </div>
            <ul className="mt-6 space-y-3">
              {t.beforeAfter.beforeItems.map((it, i) => (
                <li key={i} className="flex items-start gap-3 text-ink/80">
                  <span className="mt-1 grid h-5 w-5 place-items-center rounded-full hairline flex-shrink-0"
                        style={{ background: "rgba(255,59,59,0.10)" }}>
                    <X size={12} color="#FF3B3B" />
                  </span>
                  <span className="text-[15px] leading-relaxed">{it}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* AFTER */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.1 }}
            className="relative card-tactical p-6 md:p-8 overflow-hidden border-primary/30"
            style={{ background: "linear-gradient(180deg, rgba(0,255,136,0.06), #1C1F26 60%)", borderColor: "rgba(0,255,136,0.25)" }}
            data-testid="after-card"
          >
            <div className="flex items-center gap-3">
              <span className="label-tag neon-text">{t.beforeAfter.after}</span>
              <span className="h-px flex-1 bg-primary/30" />
              <span className="mono-num text-[10px] neon-text">+ STATE</span>
            </div>
            <ul className="mt-6 space-y-3">
              {t.beforeAfter.afterItems.map((it, i) => (
                <li key={i} className="flex items-start gap-3 text-ink">
                  <span className="mt-1 grid h-5 w-5 place-items-center rounded-full flex-shrink-0"
                        style={{ background: "rgba(0,255,136,0.18)" }}>
                    <Check size={12} color="#00FF88" />
                  </span>
                  <span className="text-[15px] leading-relaxed">{it}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
